import React from "react";
import clsx from "clsx";
import DateHelper from '../../DateHelper/DateHelper';

class SeasonPresenterGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} style={{marginBottom: -18}}>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <div>{this.props.code}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <div>{this.props.name}</div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <div>{I18n.t(this.props.status)}</div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('season_type')}</label>
              <div>{I18n.t(this.props.season_type)}</div>
            </div>
          </div>
        </div>
        {this.props.season_type == 'exact_dates' ? this.renderExactDatesForm() : null}
        {this.props.season_type == 'holiday' ? this.renderHolidayForm() : null}
      </div>
    );
  }

  renderHolidayForm() {
    return (
      <div className="card" style={{paddingBottom: 0, background: 'transparent', marginBottom: 15}}>
        <h5 className="panel-heading-text">{I18n.t('holiday')}</h5>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('holiday_region')}* `}<span className="ss-help help" title={I18n.t('holiday_region_helper_text')}></span></label>
                <div>{this.props.holiday_region}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('holiday_year')}* `}</label>
                <div>{this.props.holiday_year}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('holiday_name')}* `}<span className="ss-help help" title={I18n.t('holiday_name_helper_text')}></span></label>
                <div>{this.props.holiday_name}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('days_before')}* `}<span className="ss-help help" title={I18n.t('holiday_days_before_helper_text')}></span></label>
                <div>{this.props.holiday_days_before}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('days_after')}* `}<span className="ss-help help" title={I18n.t('holiday_days_after_helper_text')}></span></label>
                <div>{this.props.holiday_days_after}</div>
            </div>
          </div>
          {/* <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('repeats')}</label>
                <div>{I18n.t(this.props.repeats)}</div>
            </div>
          </div> */}
        </div>
      </div>
    )
  }

  renderExactDatesForm() {

    return (
      <div className="card" style={{paddingBottom: 0, background: 'transparent', marginBottom: 15}}>
        <h5 className="panel-heading-text">{I18n.t('exact_dates')}</h5>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('begins')}*`} <span className="ss-help help" title={I18n.t('season_start_date_helper_text')}></span></label>
              <div>{this.props.exact_start_date ? DateHelper.printDateToScreen(this.props.exact_start_date, this.props.date_format) : null}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('ends')}*`} <span className="ss-help help" title={I18n.t('season_end_date_helper_text')}></span></label>
              <div>{this.props.exact_end_date ? DateHelper.printDateToScreen(this.props.exact_end_date, this.props.date_format) : null}</div>
            </div>
          </div>
          {/* <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('repeats')}</label>
                <div>{I18n.t(this.props.repeats)}</div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }

}

export default SeasonPresenterGeneral
